export const baseURL = process.env.REACT_APP_API_URL;
export const socketURL = "http://192.168.1.9:8000";

export const ApiURL = {
  //*********************************** Auth ****************************************** //

  login: "/admin-api/login-user/",
  logout: "/admin-api/logout-view/",
  password_reset: "/admin-api/forget-password/",

  //*********************************** Admin ****************************************** //
  free_registration_list: "/admin-api/free-registration-list/",
  change_company_status: "/admin-api/demo-requested/",
  demo_given_list: "/admin-api/demo-given-list/",
  trial_request: "/admin-api/free-trial-requested/",
  free_trial_list: "/admin-api/free-trial-list/",
  change_trial_status: "/admin-api/trial-complete/",
  block_trial_request: "/admin-api/stopped-trial/",
  free_trial_expired_list: "/admin-api/free-trial-expiry/",
  paid_subscription_list: "/admin-api/paid-subscription-list/",
  logbooks_list: "/admin-api/logbooks-list/",
  packages_list: "/admin-api/packages-list/",
  price_selection: "/admin-api/prices-selection/",
  get_ships_by_company: "/admin-api/get-ships-by-company/",
  invoice_email: "/admin-api/invoice-email/",
  add_logbook: "/admin-api/select-logbooks-add/",
  delete_logbook: "/admin-api/logbooks-delete/",
  assign_logbooks: "/admin-api/select-logbooks-add/",
  paid_complete_request: "/admin-api/paid-requested-update/",
  paid_subscription_expiry_list: "/admin-api/paid-subscription-expiry-list/",
  list_voyage_info: "/staff-api/list-voyage-info/",
  staff_dashboard: "/staff-api/staff-dashboard/",
  all_machinary_on_ship_st: "/staff-api/all-machinary-on-ship/",
  list_user: "/admin-api/list-user/",
  list_roles: "/admin-api/list-roles/",
  user_add: "/admin-api/add-user/",
  user_edit: "/admin-api/edit-user/",
  all_company_lising: "/admin-api/all-company-lising/",
  admin_all_issues: "/admin-api/admin-all-issues/",
  company_bug_report_list_com: "/admin-api/admin-bug-report-list/",
  company_change_request_list_com: "/admin-api/admin-change-request-list/",
  feature_request_list_com: "/admin-api/admin-feature-request-list/",
  feedback_list_com: "/admin-api/admin-feedback-list/",
  invoice_list_admin: "/admin-api/invoice-list/",
  demo_request_list: "/admin-api/list-demo-requests/",
  general_enquiry_list: "/admin-api/list-general-inquiries/",
  demo_notification_listing: "/admin-api/demo-notifications/",
  get_user_details: "/admin-api/get-user-details/",
  delete_user: "/admin-api/delete-user/",
};

//*********************************** Dwonload Pdf Url ****************************************** //

export const bunkerpdfdownloadUrl = "staff-api/generate-bunker-log-pdf";
export const generatesulphurbd = "staff-api/generate-sulphur-bd-pdf";
export const generatesulphurbdn = "staff-api/generate-sulphur-bdn-pdf";
export const generatesulphurfcr = "staff-api/generate-sulphur-fcr-pdf";
export const generatecargopdf = "staff-api/generate-cargo-log-pdf";
